<template>
  <div v-if="showInfo.maskingFlag">
    <el-empty :description="TLang('暂不支持查看', 'my')"></el-empty>
  </div>
  <div v-else>
    <!-- 吸顶 -->
    <div class="ontop" v-if="showTop">
      <div class="topwrap">
        <el-tabs v-model="showWitch" @tab-click="handleClick" v-if="!CheckCN()">
          <el-tab-pane label="Show details" name="1"></el-tab-pane>
          <el-tab-pane label="Ticket INS" name="2"></el-tab-pane>
          <el-tab-pane label="Ticketing notice" name="3"></el-tab-pane>
        </el-tabs>
        <el-tabs v-model="showWitch" @tab-click="handleClick" v-if="CheckCN()">
          <el-tab-pane label="演出详情" name="1"></el-tab-pane>
          <el-tab-pane label="购票说明" name="2"></el-tab-pane>
          <el-tab-pane label="购票须知" name="3"></el-tab-pane>
        </el-tabs>

        <div
          :class="{ nowbuy: true, diasbel: !timeId || !priceId || !usable }"
          @click="buyNow"
          v-if="
            !hasSeat &&
            hasSeat != 6 &&
            !showLogInfo &&
            (projectStatus != 6 || (projectStatus == 6 && buyAble))
          "
        >
          {{ TLang('立即购票', 'my') }}
        </div>
        <div
          v-if="
            hasSeat &&
            (projectStatus != 6 || (projectStatus == 6 && buyAble)) &&
            !showLogInfo
          "
          :class="{
            nowbuy: true,
            diasbel: !timeId || !priceId || projectStatus != 1 || !usable,
          }"
          @click="chooseSeat"
        >
          {{ TLang('立即选座', 'my') }}
        </div>

        <div
          :class="{ nowbuy: true }"
          @click="openLog"
          v-show="showLogInfo && usable"
        >
          {{ TLang('缺票登记', 'my') }}
        </div>

        <div
          class="nowbuy wait"
          v-show="projectStatus == 6 && !showLogInfo && !buyAble && usable"
        >
          {{ TLang('待开售', 'my') }}
        </div>
      </div>
    </div>
    <div class="detail">
      <div class="top">
        <showPage
          :listName="showInfo.categoryName"
          :showName="showInfo.projectName"
          :parentId="showInfo.parentid"
          :city="showInfo.cityId"
          :categoryId="showInfo.categoryId"
        />
      </div>
      <div class="main">
        <div class="showImg">
          <img :src="showInfo.showPic" alt class="goodsImg" />
          <div
            class="preview"
            v-if="showInfo.projectStatus == 1 && showInfo.projectType == 1"
          >
            <img src="@/assets/imgs/index/preview_detail.png" alt />
          </div>
        </div>
        <div class="showInfo">
          <div class="title">{{ showInfo.projectName }}</div>
          <div
            class="tips"
            v-if="showInfo.projectStatus == 1 && showInfo.projectType == 1"
          >
            <img src="@/assets/imgs/index/Group.png" alt />
            <span>{{ TLang('本商品为预售商品', 'my') }}</span>
          </div>
          <!-- projectStatus为6时候为待开售，才会展示这个状态 -->
          <div class="tips" v-show="projectStatus == 6 && !buyAble">
            <img src="@/assets/imgs/index/Group.png" alt />
            <span
              >{{ TLang('距离开售还有', 'my')
              }}<span class="bigFont">{{ cutDown.d }}</span
              >{{ TLang('天', 'list')
              }}<span class="bigFont">{{ cutDown.h }}</span
              >{{ TLang('时', 'my')
              }}<span class="bigFont">{{ cutDown.m }}</span
              >{{ TLang('分', 'my')
              }}<span class="bigFont">{{ cutDown.s }}</span
              >{{ TLang('秒', 'my') }}</span
            >
          </div>
          <div class="time">
            <img src="@/assets/imgs/index/time.png" alt />
            <span>{{ showInfo.timeInfo }}</span>
          </div>
          <div class="location">
            <img src="@/assets/imgs/index/location.png" alt />
            <span>{{ showInfo.venueName }}</span>
            <span class="line"></span>
            <span>{{ showInfo.cityName }}</span>
            <span class="address">{{ showInfo.streetAddress }}</span>
          </div>
          <div class="chang">
            <div class="title1">{{ TLang('场次', 'my') }}</div>
            <div class="showList">
              <ul>
                <li
                  :class="{
                    soldOut:
                      !item.performStatus ||
                      !item.usable ||
                      item.isSoldOut == 1,
                    select: item.id == timeId,
                  }"
                  v-for="(item, index) in showInfo.mallTicketPerformDtos"
                  :key="index"
                  @click="checkTime(item)"
                >
                  {{ item.performName }}
                  <!-- 套票标识 -->
                  <div
                    class="prevent"
                    v-if="
                      item.mallTicketPriceDtos.filter((x) => x.priceType != 0)
                        .length
                    "
                  >
                    <img
                      :src="
                        !CheckCN()
                          ? require(`@/assets/imgs/youhuiEN-3倍.png`)
                          : require(`@/assets/imgs/youhui.png`)
                      "
                      alt
                    />
                  </div>
                  <!-- 预售标识 -->
                  <div
                    class="prevent"
                    v-if="item.saleType == 1 && item.performStatus"
                  >
                    <img
                      :src="
                        !CheckCN()
                          ? require(`@/assets/imgs/index/yushouEN-3倍.png`)
                          : require(`@/assets/imgs/index/yushou.png`)
                      "
                      alt
                    />
                  </div>
                  <!-- 售罄标识 -->
                  <div class="out" v-if="!item.performStatus">
                    <img
                      :src="
                        !CheckCN()
                          ? require(`@/assets/imgs/index/shouqingEN-3倍.png`)
                          : require(`@/assets/imgs/index/shouqing.png`)
                      "
                      alt
                    />
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="ticket" v-if="list.length > 0">
            <div class="title1">{{ TLang('票档', 'my') }}</div>
            <div class="showList">
              <ul>
                <!-- <li class="select">早鸟票980元</li> -->
                <li
                  :class="{
                    soldOut: !item.ticketStatus && item.subStatus != 0,
                    select: item.id == priceId,
                  }"
                  @click="selectPrice(item)"
                  v-for="(item, index) in list"
                  :key="index"
                >
                  {{ item.priceName ||  item.ticketPrice}}

                  <!-- 套票标识 -->
                  <div class="prevent" v-if="item.priceType != 0">
                    <img
                      :src="
                        !CheckCN()
                          ? require(`@/assets/imgs/youhuiEN-3倍.png`)
                          : require(`@/assets/imgs/youhui.png`)
                      "
                      alt
                    />
                  </div>
                  <!-- 预售标识 -->
                  <div
                    class="prevent"
                    v-if="item.saleType && item.ticketStatus"
                  >
                    <img
                      :src="
                        !CheckCN()
                          ? require(`@/assets/imgs/index/yushouEN-3倍.png`)
                          : require(`@/assets/imgs/index/yushou.png`)
                      "
                      alt
                    />
                  </div>
                  <!-- 售罄标识 -->
                  <div v-if="!item.ticketStatus" class="prevent">
                    <img
                      :src="
                        !CheckCN()
                          ? require(`@/assets/imgs/index/shouqingEN-3倍.png`)
                          : require(`@/assets/imgs/index/shouqing.png`)
                      "
                      alt
                    />
                  </div>
                  <!-- "@/assets/imgs/index/SoldOut.png" -->
                  <!-- 缺票标识 -->
                  <div v-if="item.subStatus == 0" class="prevent">
                    <!-- 等到图片 -->
                    <img
                      :src="
                        !CheckCN()
                          ? require(`@/assets/imgs/quepiaoEN-3倍.png`)
                          : require(`@/assets/imgs/quepiao.png`)
                      "
                      alt
                    />
                  </div>
                </li>
              </ul>
            </div>
            <div
              class="group"
              v-if="
                priceObj.hasOwnProperty('priceType') && priceObj.priceType != 0
              "
            >
              1{{ TLang('份', 'my') }}{{ priceObj.ticketPrice
              }}{{ TLang('元套票包含', 'my') }}
              {{
                priceObj.subPrices &&
                priceObj.subPrices.reduce(function (total, value, index) {
                  return (
                    total +
                    String(value.count) +
                    TLang('张', 'my') +
                    String(value.ticketPrice) +
                    TLang('元', 'my') +
                    (index == priceObj.subPrices.length - 1 && CheckCN()
                      ? '的票'
                      : '、')
                  )
                }, '')
              }}
            </div>
          </div>
          <div class="count" v-if="!hasSeat">
            <div class="title1">{{ TLang('数量', 'home') }}</div>
            <div class="showList">
              <i
                :class="
                  number == 1
                    ? 'el-icon-minus minusNumber disable'
                    : 'el-icon-minus minusNumber'
                "
                @click="minusNum"
              ></i>
              <span class="Num">{{ number }}</span>
              <i
                :class="
                  number == 6
                    ? 'el-icon-plus addNumber disable'
                    : 'el-icon-plus addNumber'
                "
                @click="addNum"
              ></i>
              <span class="tips1"
                >{{ TLang('每笔订单限购', 'my') }}{{ max
                }}{{ TLang('单', 'my') }}</span
              >
            </div>
          </div>
          <div class="total">
            <div class="title1">{{ TLang('合计', 'my') }}</div>
            <div class="showList">
              <img :src="unionInfo.icon ? unionInfo.icon : fudou" alt />
              <span class="price">{{ totalPrice }}</span>
              <!-- 普通单票 -->
              <span class="singlePrice" v-if="priceObj.priceType == 0"
                >{{ ticketPrice }}/{{ TLang('张', 'my') }}</span
              >
              <!-- 套票展示删除标签 -->
              <del
                v-if="
                  priceObj.priceType != 0 &&
                  priceObj.subPrices &&
                  priceObj.subPrices.reduce(function (total, value) {
                    return total + (value.count * value.ticketPrice * 100) / 100
                  }, 0) *
                    number *
                    (unionInfo.scale ? unionInfo.scale : 1) >
                    totalPrice
                "
                style="color: #999; margin-left: 8px"
                >{{
                  (
                    priceObj.subPrices.reduce(function (total, value) {
                      return (
                        total + (value.count * value.ticketPrice * 100) / 100
                      )
                    }, 0) *
                    number *
                    (unionInfo.scale ? unionInfo.scale : 1)
                  ).toFixed(2)
                }}</del
              >
            </div>
          </div>
          <div class="tobuy">
            <div
              v-if="
                !hasSeat &&
                hasSeat != 6 &&
                !showLogInfo &&
                (projectStatus != 6 || (projectStatus == 6 && buyAble))
              "
              :class="{
                showList: true,
                diasbel: !timeId || !priceId || !usable,
              }"
              @click="buyNow"
            >
              {{ TLang('立即购票', 'my') }}
            </div>

            <div
              v-if="
                hasSeat &&
                (projectStatus != 6 || (projectStatus == 6 && buyAble)) &&
                !showLogInfo
              "
            >
              <div
                :class="{
                  showList: true,
                  diasbel: !timeId || !priceId || projectStatus != 1 || !usable,
                }"
                @click="chooseSeat"
              >
                {{ TLang('立即选座', 'my') }}
              </div>
              <div class="wramTip" v-if="unionFlag">
                {{ TLang('因合作商调整', 'my') }}
              </div>
            </div>

            <div
              :class="{ showList: true }"
              @click="openLog"
              v-show="showLogInfo && usable"
            >
              {{ TLang('缺票登记', 'my') }}
            </div>
            <div
              :class="{ showList: true, wait: true }"
              v-show="projectStatus == 6 && !showLogInfo && !buyAble && usable"
            >
              {{ TLang('待开售', 'my') }}
            </div>
            <el-dialog
              class="dialogShow"
              :visible.sync="logShow"
              width="528px"
              height="258px"
              :before-close="closeLog"
              :title="TLang('缺票登记', 'my')"
              style="text-align: center"
            >
              <el-form>
                <el-form-item label="手机号" prop="kuaidiName">
                  <el-input
                    class="mobileInput"
                    type="text"
                    :inline="true"
                    v-model="logForm.mobile"
                    autocomplete="off"
                    :placeholder="TLang('请输入手机号', 'address')"
                    @input="formatTelphone"
                  ></el-input>
                </el-form-item>
                <div
                  class="logintips"
                  style="margin-bottom: 4px"
                  v-if="hasreceive"
                >
                  <img :src="staticAssets.ImgObj.input_error_icon" alt="" />
                  <span style="color: #f44545">{{ logText }}</span>
                </div>
                <div class="logintips">
                  <img :src="staticAssets.ImgObj.tip_info_icon" alt="" />
                  <span>{{ TLang('一旦有票', 'my') }}</span>
                </div>
                <div class="logBtn">
                  <div class="submitLog" @click="submitLog">
                    {{ TLang('提交', 'my') }}
                  </div>
                  <div class="cancelLog" @click="closeLog">
                    {{ TLang('取消', 'home') }}
                  </div>
                </div>
              </el-form>
            </el-dialog>

            <el-dialog
              :visible.sync="dialogVisible"
              width="420px"
              height="258px"
              :before-close="handleClose"
              style="text-align: center"
            >
              <div
                style="
                  width: 148px;
                  height: 148px;
                  padding: 12px;
                  border: 1px solid #e0e6ed;
                  margin: 0 auto;
                "
              >
                <!-- :logoSrc="icon"  :logoScale="0"-->
                <vue-qr
                  :text="url"
                  :margin="0"
                  colorDark="#000"
                  colorLight="#fff"
                  :size="124"
                ></vue-qr>
              </div>
              <div
                style="
                  font-size: 18px;
                  color: #3d96e2;
                  margin-top: 19px;
                  line-height: 20px;
                "
              >
                {{ TLang('微信扫一扫', 'home') }}
              </div>
              <div
                style="
                  font-size: 12px;
                  color: #000;
                  height: 20px;
                  line-height: 20px;
                "
              >
                {{ TLang('使用微信扫码立即选座', 'my') }}
              </div>
            </el-dialog>
          </div>
        </div>
      </div>
      <div class="botInfo" ref="tabsPane" v-if="!CheckCN()">
        <el-tabs v-model="showWitch" @tab-click="handleClick">
          <el-tab-pane label="Show details" name="1"></el-tab-pane>
          <el-tab-pane label="Ticket INS" name="2"></el-tab-pane>
          <el-tab-pane label="Ticketing notice" name="3"></el-tab-pane>
        </el-tabs>
      </div>
      <div class="botInfo" ref="tabsPane" v-if="CheckCN()">
        <el-tabs v-model="showWitch" @tab-click="handleClick">
          <el-tab-pane label="演出详情" name="1"></el-tab-pane>
          <el-tab-pane label="购票说明" name="2"></el-tab-pane>
          <el-tab-pane label="购票须知" name="3"></el-tab-pane>
        </el-tabs>
      </div>
      <div class="detail">
        <!-- 详情  英文版-->
        <div ref="info1" v-if="!CheckCN()">
          <tops title="Show details" />
          <div
            v-html="showInfo.showDetail"
            ref="detail"
            class="detailContent"
          ></div>
        </div>
        <!-- 详情  中文版-->
        <div ref="info1" v-if="CheckCN()">
          <tops title="演出详情" />
          <div
            v-html="showInfo.showDetail"
            ref="detail"
            class="detailContent"
          ></div>
        </div>
        <!-- 购票说明 -->
        <div ref="info2">
          <tops v-if="!CheckCN()" title="Ticket INS" />
          <tops v-if="CheckCN()" title="购票说明" />
          <question
            :question="item.question"
            :answer="item.answer"
            style="padding-bottom: 24px"
            :img="item.img"
            v-for="(item, index) in kownList"
            :key="index"
            v-show="item.answer"
          ></question>
        </div>
        <div ref="info3">
          <tops v-if="!CheckCN()" title="Ticketing notice" />
          <tops v-if="CheckCN()" title="购票须知" />
          <question
            :question="item.question"
            :answer="item.answer"
            style="padding-bottom: 24px"
            :img="item.img"
            v-for="(item, index) in listThree"
            :key="index"
            v-show="item.answer"
          ></question>
        </div>
        <div style="height: 80px"></div>
      </div>
    </div>
    <message v-if="logSuccess" />
    <div class="logTextOut" v-if="logTextOut">
      <div class="font">{{ TLang('已经收到您的缺票登记', 'my') }}</div>
    </div>
  </div>
</template>

<script>
import showPage from '@/components/showList/showPage.vue'
import question from '@/components/detail/answer.vue'
import tops from '@/components/detail/tops.vue'
import message from '@/components/message/index.vue'
import { mapState, mapMutations } from 'vuex'
import { unionFlag, dateFormat } from '@/utils'
import { setTitleInfo } from '@/utils/title'
import { sha } from '@/utils/SHA'
import { getCookie } from '@/utils'
import { TLang } from '@/utils/lang'
import vueQr from 'vue-qr'
export default {
  name: 'detail',
  data() {
    return {
      watchTel_flag: '', // 记录手机号输入前得值
      unionFlag: unionFlag(),
      dialogVisible: false,
      url: '',
      icon: require('@/assets/imgs/index/logo.png'),
      fudou: require('@/assets/imgs/index/fudou.png'),
      showTop: false,
      showWitch: '1',
      showInfo: {},
      list: [], // 票档列表
      number: 1, // 默认购买一张
      timeId: '', //选中得场次id
      priceId: '', //选中得priceId
      usable: true, //当前场次是否过期
      priceObj: {},
      max: 6,
      min: 1,
      kownList: [],
      listThree: [],
      scrollTopList: [],
      parentId: '',
      categoryId: '',
      cityId: '',
      ticketPrice: '', //单价
      hasSeat: 0, // 当前场次是否可以选座, 默认不可以
      logShow: false, // 控制缺票等级弹窗开关
      showLogInfo: false, // 判断是否展示缺票登记按钮
      logForm: {
        mobile: '', //缺票登记手机号
      },
      hasreceive: false, //是否已经收到当前的缺票登记
      projectStatus: '', //项目销售状态，1-销售中；6-定时开始（倒计时）；4-取消；5-结束 除了1之外，其他均为不可售。6为倒计时
      showStartTimeStamp: 0, //项目开售时间
      cutDown: {
        d: '00',
        h: '00',
        m: '00',
        s: '00',
      },
      logSuccess: false, // 控制缺票登记成功弹窗
      logTextOut: false,
      logText: '', //缺票登记失败原因展示
      buyAble: false, // 控制是否倒计时完成， 如果倒计时完成则可以购买
      ticketStatus: 0, // 整场演出是否可售， 0不可售 1可售
      CookiesOne: getCookie('df_lang'),
      CookiesOneFlag: getCookie('df_lang') === 'en-US' ? true : false,
      SoldOuta: '@/assets/imgs/index/SoldOut.png',
    }
  },
  components: {
    showPage,
    question,
    tops,
    vueQr,
    message,
  },
  created() {
    const union = unionFlag()
    if (union && union !== 'stage') {
      this.apis.home.getBili().then((data) => {
        if (data.respCode === '00000000') {
          this.setUnionInfo(data)
        } else {
          this.setUnionInfo({})
        }
        this.getDetail(this.$route.query.id)
      })
    } else {
      this.getDetail(this.$route.query.id)
    }
  },
  computed: {
    ...mapState({
      unionInfo: 'unionInfo',
    }),
    totalPrice() {
      if (this.priceObj.ticketPrice) {
        let price = this.unionInfo.scale
          ? (this.priceObj.ticketPrice *
              100 *
              this.number *
              this.unionInfo.scale) /
            100
          : (this.priceObj.ticketPrice * 100 * this.number) / 100
        if (/\d/.test(price) && /\./.test(price)) {
          price = price.toString().split('.')
        } else {
          price = [`${price}`, '00']
        }
        return price.join('.')
      }
      return 0
    },
  },
  methods: {
    ...mapMutations(['setUnionInfo']),
    // 手机号格式化
    formatTelphone() {
      this.watchTel = this.logForm.mobile.replace(/\D/g, '')
      let telLength = this.watchTel.length
      //增加
      if (this.watchTel.length > this.watchTel_flag.length) {
        if (telLength == 4 || telLength == 8) {
          this.logForm.mobile =
            this.logForm.mobile.slice(0, this.logForm.mobile.length - 1) +
            ' ' +
            this.logForm.mobile.slice(-1)
        }
      } else {
        //删除
        if (this.watchTel_flag.length == 4 || this.watchTel_flag.length == 8) {
          this.logForm.mobile = this.logForm.mobile.trim()
        }
      }
    },
    reload() {
      this.apis.showOrder
        .getLoginStatus({
          platform: 0,
          unionFlag: unionFlag() ? 1 : 0,
          union: unionFlag() ? unionFlag() : 0,
        })
        .then((res) => {
          if (res.loginFlag === 0) {
            window.df_sdk_common.location.href =
              res.loginUrl +
              '&returnUrl=' +
              encodeURIComponent(window.df_sdk_common.location.href)
          }
        })
    },
    // 缺票登记 点击确定
    submitLog() {
      var reg = new RegExp('\\s', 'g')
      const mobile = this.logForm.mobile.replace(reg, '')
      if (!/^1[13456789]\d{9}$/.test(mobile)) {
        this.$message('手机号码有误，请重填')
        return false
      } else {
        this.apis.home
          .logTicket({
            priceId: this.priceId,
            phone: mobile,
          })
          .then((res) => {
            if (res && res.code == 101002) {
              this.$message({
                showClose: true,
                message: this.TLang('请重新登录', 'home'),
                type: 'error',
                onClose: () => {
                  this.reload()
                },
              })
            } else {
              if (!res.body) {
                // this.hasreceive = true; //已经收到缺票登记
                // this.logText = res.msg || "已经收到您的缺票登记";
                this.logTextOut = true
                setTimeout(() => {
                  this.logTextOut = false
                }, 2000)
              } else {
                this.hasreceive = false
                this.logShow = false
                this.logSuccess = true
                setTimeout(() => {
                  this.logSuccess = false
                  this.logForm.mobile = ''
                }, 2000)
              }
            }
          })
      }
    },
    openLog() {
      this.logShow = true
      this.hasreceive = false
      this.logForm.mobile = ''
    },
    closeLog() {
      this.logShow = false
      this.hasreceive = false
      this.logForm.mobile = ''
    },
    handleClose() {
      this.dialogVisible = false
    },
    chooseSeat() {
      if (
        this.projectStatus != 1 ||
        !this.timeId ||
        !this.priceId ||
        !this.usable
      ) {
        this.$message(TLang('抱歉,当前场次暂不可售', 'my'))
        // 抱歉，当前场次不可售

        return
      }
      let baseURL = window.df_sdk_common.getH5LocationOriginByPcUrl()
      this.url = unionFlag()
        ? `${baseURL}/drama_h5/show/detail/${
            this.$route.query.id
          }?union=${unionFlag()}&city=${this.$route.query.city}`
        : `${baseURL}/drama_h5/show/detail/${this.$route.query.id}?city=${this.$route.query.city}`

      this.apis.headerApi.getLoginStatus().then((res) => {
        if (res.loginFlag === 1) {
          // 已登录
          this.getAuthCode()
        } else {
          // 未登录
          this.dialogVisible = true
        }
      })
    },
    getAuthCode() {
      // 获取授权登录码
      let dfflone = ''
      const unionCode = unionFlag()
      if (unionCode) {
        dfflone = window.df_sdk_common.getCookieToken(
          'dfflone_union_' + unionCode
        )
      } else {
        dfflone = window.df_sdk_common.getCookieToken('dfflone')
      }
      const params = {
        appId: this.appCode,
        msgId: '4ac05cd2-1ee2-409a-8f44-517bb10faadf',
        timestamp: +new Date(),
        version: '1.0.1',
        body: JSON.stringify({ sourceWay: 1, tokenType: '2' }), // 与后台协定tokenType 写死2
        sign: '',
      }
      params.sign = sha(this.appSecret + params.body + this.appSecret)
      this.apis.showOrder.getAuthCode(params).then((res) => {
        if (res.code === 200) {
          let u = this.url + '&loginKey=' + res.data.loginKey
          console.log(u)
          this.url = u
        }
        this.dialogVisible = true
      })
    },
    handleClick(tag) {
      window.scrollTo({
        top: this.scrollTopList[Number(tag.name) - 1] - 67,
        behavior: 'smooth',
      })
      this.showWitch = tag.name
    },
    buyNow() {
      if (!this.timeId || !this.priceId || !this.usable) {
        this.$message(TLang('抱歉,当前无可选场次', 'my'))
      } else {
        let confirmSource = {
          id: this.showInfo.id,
          performId: this.timeId,
          priceId: this.priceId,
          quantity: this.number,
        }
        this.apis.showOrder.getConfirmSource(confirmSource).then((res) => {
          if (!res.code) {
            const curPerform = this.showInfo.mallTicketPerformDtos.find(v => v.id === this.timeId) || {};
            const data = Object.assign({}, res.body, {
              fetchticketId: curPerform.defFetchticketId,
              supplierId: this.showInfo.supplierId,
              performId:  this.timeId,
              supplierFetchTicketWayId: curPerform.defSupplierFetchTicketId
            })
            sessionStorage.setItem("table_source", JSON.stringify(data));
            this.$router.push({
              path: '/order/confirm',
              query: confirmSource,
            })
          } else if (res && res.code && res.code === 101002) {
            // let baseOrigin = window.location.origin;
            this.$message({
              showClose: true,
              message: this.TLang('请重新登录', 'home'),
              type: 'error',
              onClose: () => {
                this.reload()
              },
            })
          }
        })
      }
    },
    minusNum() {
      if (this.number > 1) {
        this.number--
        this.disabelminus = false
      } else {
        this.disabelminus = true
      }
    },
    addNum() {
      if (this.number < this.max) {
        this.number++
        this.disableAdd = false
      } else {
        this.disableAdd = true
      }
    },
    // 选择场次
    checkTime(item) {
      if (item.performStatus && item.usable && item.isSoldOut != 1) {
        // 可售
        this.list = item.mallTicketPriceDtos
        this.timeId = item.id
        this.hasSeat = item.hasSeat
        this.priceObj = {} // 清空当前已选择票档
        this.priceId = ''
        for (let i = 0; i < this.list.length; i++) {
          if (this.list[i].ticketStatus || this.list[i].subStatus == 0) {
            // 可售 或者 缺票 为可选择状态
            this.priceId = this.list[i].id
            this.priceObj = this.list[i]
            this.ticketPrice = this.unionInfo.scale
              ? this.priceObj.ticketPrice * this.unionInfo.scale
              : this.priceObj.ticketPrice
            if (this.list[i].subStatus == 0) {
              this.showLogInfo = true
            } else {
              this.showLogInfo = false
            }
            break
          }
        }
      } else {
        this.$message(TLang('抱歉，当前场次不可售', 'my'))
      }
    },
    // 选择票档
    selectPrice(item) {
      // 可售状态或者缺票状态下为可选择状态
      if (item.ticketStatus || item.subStatus == 0) {
        this.priceId = item.id
        this.priceObj = item
        if (item.priceType != 0) {
          // 套票
          let totalIn = item.subPrices.reduce(function (total, value) {
            return total + value.count
          }, 0)
          this.max = Math.floor(6 / totalIn)
          this.number = 1
        } else {
          this.max = 6
          this.number = 1 //选择数量归位
        }
        this.ticketPrice = this.unionInfo.scale
          ? this.priceObj.ticketPrice * this.unionInfo.scale
          : this.priceObj.ticketPrice // 工会计算比例
      } else {
        this.$message(TLang('抱歉，当前票档不可售', 'my'))
      }

      if (item.subStatus == 0) {
        this.showLogInfo = true
      } else {
        this.showLogInfo = false
      }
    },
    getDetail(id) {
      this.apis.home.getDetail({ id }).then((res) => {
        this.showInfo = res.body
        this.parentId = res.body.parentId
        this.categoryId = res.body.categoryId
        this.cityId = res.body.cityId
        this.projectStatus = res.body.projectStatus // 项目销售状态，1-销售中；6-定时开始（倒计时）；4-取消；5-结束 除了1之外，其他均为不可售。6为倒计时
        this.showStartTimeStamp = res.body.showStartTimeStamp //项目开售时间
        this.usable = res.body.usable

        setTitleInfo({ address: res.body.projectName })
        if (
          new Date(this.showStartTimeStamp).getTime() > new Date().getTime() // 判断当前是否已经开售，若当前时间戳小于 开售时间，则待开售，倒计时模块展示
        ) {
          var cut = setInterval(() => {
            let cutDownStamp =
              new Date(this.showStartTimeStamp).getTime() - new Date().getTime()
            this.cutDown.d = dateFormat(cutDownStamp, 'dd')
            this.cutDown.h = dateFormat(cutDownStamp, 'hh')
            this.cutDown.m = dateFormat(cutDownStamp, 'mm')
            this.cutDown.s = dateFormat(cutDownStamp, 'ss')
            this.buyAble = false
            if (
              this.cutDown.d == 0 &&
              this.cutDown.h == 0 &&
              this.cutDown.m == 0 &&
              this.cutDown.s == 0
            ) {
              clearInterval(cut)
              this.buyAble = true
            }
          }, 1000)
        } else {
          this.buyAble = true
        }
        this.kownList = [
          {
            question: TLang('发票说明', 'my'),
            answer: TLang('因福利卡券在购买时', 'my'),
          },
          {
            question: TLang('是否支持选座', 'my'),
            answer: this.showInfo.choiceSeatNotice,
            // img: require("../../assets/imgs/index/limit.png")
          },
          {
            question: TLang('实名制购票', 'my'),
            answer: this.showInfo.realNameNotice,
            // img: require("../../assets/imgs/index/people.png")
          },
          {
            question: TLang('儿童购票说明', 'my'),
            answer: this.showInfo.childrenNotice,
            // img: require("../../assets/imgs/index/people.png")
          },
          {
            question: TLang('退换政策', 'my'),
            answer: this.showInfo.policyOfReturn,
            // img: require("../../assets/imgs/index/tui.png")
          },
          {
            question: TLang('入场说明', 'my'),
            answer: this.showInfo.entranceNotice,
            // img: require("../../assets/imgs/index/tui.png")
          },
          {
            question: TLang('电子票入场提示', 'my'),
            answer: this.showInfo.eticketNotice,
            // img: require("../../assets/imgs/index/tui.png")
          },
          {
            question: TLang('自动取票', 'my'),
            answer: this.showInfo.selfGetTicketNotice,
            // img: require("../../assets/imgs/index/tui.png")
          },
        ]
        this.listThree = [
          {
            question: TLang('演出开售时间', 'my'),
            answer: this.showInfo.showStartTimeStamp,
            // img: require("../../assets/imgs/index/jin.png")
          },
          {
            question: TLang('演出销售结束时间', 'my'),
            answer: this.showInfo.showEndTimeStamp,
            // img: require("../../assets/imgs/index/jin.png")
          },
          {
            question: TLang('寄存说明', 'my'),
            answer: this.showInfo.depositInfo,
            // img: require("../../assets/imgs/index/jicun.png")
          },
          {
            question: TLang('禁止携带物品说明', 'my'),
            answer: this.showInfo.prohibitedItems,
            // img: require("../../assets/imgs/index/jin.png")
          },
        ]
        // 获取第一个可售的场次
        for (let i = 0; i < res.body.mallTicketPerformDtos.length; i++) {
          if (
            res.body.mallTicketPerformDtos[i].performStatus &&
            res.body.mallTicketPerformDtos[i].usable &&
            res.body.mallTicketPerformDtos[i].isSoldOut != 1
          ) {
            this.timeId = res.body.mallTicketPerformDtos[i].id
            this.hasSeat = res.body.mallTicketPerformDtos[i].hasSeat
            this.list = res.body.mallTicketPerformDtos[i].mallTicketPriceDtos
            break
          }
        }
        //获取第一个可售场次下面的可售票档, //缺货等级状态也展示位可选，用户可进行登记
        if (this.list.length > 0) {
          for (let i = 0; i < this.list.length; i++) {
            if (
              this.list[i].ticketStatus ||
              (this.list[i].ticketStatus == 0 && this.list[i].subStatus == 0)
            ) {
              // 可售
              this.priceId = this.list[i].id
              this.priceObj = this.list[i]
              this.ticketPrice = this.unionInfo.scale
                ? this.priceObj.ticketPrice * this.unionInfo.scale
                : this.priceObj.ticketPrice
              // 缺货登记展示按钮
              if (this.list[i].subStatus == 0) {
                this.showLogInfo = true
              } else {
                this.showLogInfo = false
              }
              // 套票需要判断当前可购买最大数量
              if (this.list[i].priceType != 0) {
                // 获取一组套票里面子票总数量
                let totalIn = this.list[i].subPrices.reduce(function (
                  total,
                  value
                ) {
                  return total + value.count
                },
                0)
                this.max = Math.floor(6 / totalIn)
                this.number = 1
              } else {
                this.max = 6
                this.number = 1 // 选择数量归位
              }
              break
            }
          }
        }
      })
    },
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      if (this.$refs.tabsPane) {
        if (this.$refs.tabsPane.offsetTop <= scrollTop) {
          this.showTop = true
        } else {
          this.showTop = false
        }
      }
      let that = this
      this.scrollTopList = (function () {
        let arr = []
        for (let i = 1; i < 4; i++) {
          if (that.$refs[`info${i}`]) {
            arr.push(that.$refs[`info${i}`].offsetTop)
          }
        }
        return arr
      })()
      this.scrollTopList.forEach((value, index) => {
        if (
          index != this.scrollTopList.length - 1 &&
          value - 67 <= scrollTop &&
          scrollTop < this.scrollTopList[index + 1] - 67
        ) {
          this.showWitch = String(index + 1)
        } else if (
          index == this.scrollTopList.length - 1 &&
          value - 67 <= scrollTop
        ) {
          this.showWitch = String(index + 1)
        }
      })
    },
  },
  watch: {
    showInfo() {
      setTimeout(() => {
        let that = this
        this.scrollTopList = (function () {
          let arr = []
          for (let i = 1; i < 4; i++) {
            if (that.$refs[`info${i}`]) {
              arr.push(that.$refs[`info${i}`].offsetTop)
            }
          }
          return arr
        })()
      })
    },
    'logForm.mobile'(newVal) {
      this.watchTel_flag = newVal.replace(/\D/g, '')
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll, false)
  },
}
</script>
<style lang="less" scoped>
/deep/.mobileInput input {
  color: #000;
}
.logTextOut {
  z-index: 999999;
  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -18px;
  margin-left: -104px;
  width: 208px;
  height: 36px;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  text-align: center;
  .font {
    line-height: 36px;
    color: white;
    font-size: 14px;
  }
}
/deep/.is-active {
  color: #000000 !important;
}
.detail {
  .wait {
    background: linear-gradient(
      200deg,
      rgba(92, 180, 236, 1) 0%,
      rgba(61, 150, 226, 1) 100%
    );
    opacity: 0.6;
  }
  .group {
    margin-left: 34px;
    line-height: 16px;
    font-size: 12px;
    margin-bottom: 10px;
    color: #b2b2b2;
  }
  .dialogShow {
    /deep/.el-dialog {
      margin-left: -264px !important;
    }

    /deep/.el-dialog__header {
      border-bottom: 1px solid rgba(0, 0, 0, 0.05);
      height: 56px;
      line-height: 56px;
      padding: 0;
    }
    /deep/.el-dialog__title {
      color: #111111;
    }
    /deep/.el-dialog__body {
      padding: 24px 59px;
    }
    /deep/.el-input {
      width: 352px;
      border: 1px solid #e5e5e5;
      outline: none;
    }
    /deep/.el-input__inner {
      border-radius: 0;
      border: none;
    }
    /deep/.el-form-item {
      margin-bottom: 8px;
    }
    .logintips {
      .clearfix;
      img {
        width: 14px;
        float: left;
        position: relative;
        top: 1px;
        margin-left: 56px;
        color: #999999;
      }
      span {
        float: left;
        margin-left: 2px;
        line-height: 17px;
        font-size: 12px;
        color: #999999;
      }
    }
    .logBtn {
      margin-top: 40px;
      text-align: center;
      display: flex;
      justify-content: center;
      .submitLog {
        width: 120px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        background: linear-gradient(
          315deg,
          rgba(92, 180, 236, 1) 0%,
          rgba(61, 150, 226, 1) 100%
        );
        border-radius: 4px;
        margin-right: 20px;
        color: white;
      }
      .cancelLog {
        width: 120px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        border-radius: 4px;
        border: 1px solid rgba(229, 229, 229, 1);
      }
    }
  }
  .bigFont {
    font-size: 16px;
    padding: 0 3px;
    font-weight: bold;
    vertical-align: bottom;
  }
  .detailContent {
    font-size: 14px !important;
    img {
      width: 100% !important;
    }
  }
  .title {
    color: #999;
  }
  width: 1200px;
  margin: auto;
  .main {
    margin-top: 23px;
    .clearfix;
    .showImg {
      width: 266px;
      height: 358px;
      float: left;
      position: relative;
      img {
        width: 100%;
        height: 100%;
      }
      .preview {
        position: absolute;
        width: 48px;
        height: 25px;
        border-radius: 0px 0px 0px 2px;
        border-radius: 0px 0px 0px 2px;
        overflow: hidden;
        color: white;
        top: 0;
        right: 0;
      }
    }
    .diasbel {
      background: rgba(213, 216, 219, 0.8) !important;
    }
    .showInfo {
      width: 902px;
      float: left;
      margin-left: 32px;
      .title {
        // height: 68px;
        line-height: 34px;
        font-size: 26px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        color: #000;
      }
      .tips {
        margin-top: 16px;
        color: #fd1d1d;
        font-size: 12px;
        height: 34px;
        line-height: 34px;
        background: rgba(253, 29, 29, 0.03);
        img {
          width: 20px;
          height: 20px;
          margin-left: 12px;
          margin-top: 7px;
          margin-right: 7px;
        }
        span {
          color: #fd1d1d;
        }
      }
      .time {
        margin-top: 16px;
        line-height: 20px;
        font-size: 14px;
        img {
          width: 16px;
          height: 16px;
          margin-top: 2px;
          display: inline-block;
        }
        span {
          margin-left: 7px;
          display: inline-block;
        }
      }
      .location {
        margin-top: 12px;
        line-height: 20px;
        font-size: 14px;
        overflow: hidden;
        position: relative;
        img {
          width: 16px;
          height: 16px;
          margin-top: 2px;
          display: inline-block;
        }
        span {
          margin-left: 7px;
          display: inline-block;
          color: #000000;
        }
        span.line {
          width: 0;
          height: 14px;
          border-left: 1px solid #ededed;
          position: relative;
          top: 3px;
          left: 0px;
          padding-right: 0px;
        }
        span.address {
          font-size: 12px;
          margin-left: 16px;
          color: #b2b2b2;
        }
      }
      .chang {
        line-height: 44px;
        margin-top: 33px;
        .clearfix;
        .title1 {
          font-size: 12px;
          color: #999999;
          height: 100%;
          float: left;
        }
        .showList {
          float: left;
          margin-left: 10px;
          width: 868px;
          .clearfix;
          ul {
            .clearfix;
            li {
              color: #000000;
              float: left;
              padding: 0 12px;
              background: rgba(233, 235, 237, 0.4);
              // background: rgba(61, 150, 226, 0.05);
              margin-right: 13px;
              cursor: pointer;
              margin-bottom: 13px;
              font-size: 14px;
              position: relative;
              .prevent {
                position: absolute;
                top: 0;
                right: 0;
                font-size: 12px;
                // width: 28px;
                text-align: center;
                line-height: 14px;
                height: 14px;
                overflow: hidden;
                background: linear-gradient(
                  202deg,
                  rgba(92, 180, 236, 1) 0%,
                  rgba(61, 150, 226, 1) 100%
                );
                border-radius: 0px 0px 0px 3px;
                color: white;
              }
              img {
                // width: 100%;
                height: 100%;
              }
            }
            li.soldOut {
              background: rgba(233, 235, 237, 0.4);
              color: #d5d8db;
              .out {
                background: rgba(213, 216, 219, 0.8);
                position: absolute;
                top: 0;
                right: 0;
                font-size: 12px;
                height: 14px;
                text-align: center;
                line-height: 14px;
                border-radius: 0px 0px 0px 3px;
                color: white;
              }
            }
            li.select {
              color: #3FA6FF;
              color: var(--df-primary-color, #3FA6FF);
              background: rgba(63, 166, 255, 0.1);
              background: var(--df-primary-color-opacity, rgba(63, 166, 255, 0.1));
            }
            li.hasSeat {
              background-color: rgba(233, 235, 237, 1);
              color: #e9ebed;
            }
          }
        }
      }
      .ticket {
        line-height: 44px;
        margin-top: 3px;
        .clearfix;
        .title1 {
          font-size: 12px;
          color: #999999;
          height: 100%;
          float: left;
        }
        .showList {
          float: left;
          margin-left: 10px;
          width: 868px;
          ul {
            .clearfix;
            li {
              color: #000000;
              font-size: 14px;
              float: left;
              padding: 0 12px;
              // background: rgba(61, 150, 226, 0.05);
              background: rgba(233, 235, 237, 0.4);
              margin-right: 13px;
              cursor: pointer;
              margin-bottom: 13px;
              position: relative;
              .prevent {
                position: absolute;
                top: 0;
                right: 0;
                font-size: 12px;
                // width: 28px;
                height: 14px;
                overflow: hidden;
                text-align: center;
                line-height: 14px;
                background: linear-gradient(
                  202deg,
                  rgba(92, 180, 236, 1) 0%,
                  rgba(61, 150, 226, 1) 100%
                );
                border-radius: 0px 0px 0px 3px;
                color: white;
                img {
                  // width: 100%;
                  height: 100%;
                }
              }
            }
            li.select {
              color: #3FA6FF;
              color: var(--df-primary-color, #3FA6FF);
              background: rgba(63, 166, 255, 0.1);
              background: var(--df-primary-color-opacity, rgba(63, 166, 255, 0.1));
            }
            li.soldOut {
              background: rgba(233, 235, 237, 0.4);
              color: #d5d8db;
              div {
                background: rgba(213, 216, 219, 0.8);
                position: absolute;
                top: 0;
                right: 0;
                font-size: 12px;
                width: 28px;
                text-align: center;
                line-height: 14px;
                border-radius: 0px 0px 0px 3px;
                color: white;
              }
            }
            li.hasSeat {
              background-color: rgba(233, 235, 237, 0.4);
              color: #d5d8db;
            }
          }
        }
      }
      .count {
        line-height: 20px;
        margin-top: 15px;
        .clearfix;
        .title1 {
          font-size: 12px;
          color: #999999;
          height: 100%;
          float: left;
        }
        .showList {
          float: left;
          margin-left: 10px;
          i {
            width: 20px;
            height: 20px;
            display: inline-block;
            text-align: center;
            line-height: 20px;
            background: rgba(233, 235, 237, 0.4);
            cursor: pointer;
            color: #3FA6FF;
            color: var(--df-primary-color, #3FA6FF);
          }
          .disable {
            background-color: rgba(233, 235, 237, 0.4);
            color: #d5d8db;
          }
          .Num {
            display: inline-block;
            font-size: 12px;
            line-height: 20px;
            width: 37px;
            text-align: center;
          }
          .tips1 {
            display: inline-block;
            font-size: 12px;
            line-height: 20px;
            color: #b2b2b2;
            margin-left: 8px;
          }
        }
      }
      .total {
        line-height: 36px;
        margin-top: 23px;
        .clearfix;
        .title1 {
          font-size: 12px;
          color: #999999;
          height: 100%;
          float: left;
        }
        .showList {
          float: left;
          margin-left: 10px;
          img {
            width: 18px;
            height: 18px;
            display: inline-block;
            margin-top: 9px;
          }
          .price {
            display: inline-block;
            font-size: 30px;
            font-weight: 500;
            color: #f44545;
            margin-left: 3px;
          }
          .singlePrice {
            display: inline-block;
            color: #999999;
            font-size: 12px;
            margin-left: 8px;
          }
        }
      }
      .tobuy {
        cursor: pointer;
        line-height: 36px;
        margin-top: 23px;
        .clearfix;
        .title1 {
          font-size: 12px;
          color: #999999;
          height: 100%;
          float: left;
        }
        .showList {
          border-radius: 4px;
          // float: left;
          margin-left: 34px;
          width: 180px;
          cursor: pointer;
          height: 44px;
          text-align: center;
          line-height: 44px;
          background: #3FA6FF;
          background: var(--df-primary-color, #3FA6FF);
          color: white;
          font-size: 16px;
        }
        .wramTip {
          margin-left: 34px;
          font-size: 10px;
          color: #999999;
        }
      }
    }
  }
  .botInfo {
    margin-top: 87px;
    .clearfix;
    /deep/.el-tabs__item.is-top {
      height: 44px;
      line-height: 40px;
      color: #999999;
      font-size: 18px;
    }
    /deep/ .el-tabs__active-bar {
      background-color: #3FA6FF;
      background-color: var(--df-primary-color, #3FA6FF);
    }
    /deep/.el-tabs__active-bar.is-top {
      width: 71px;
      height: 4px;
    }
    /deep/.el-tabs__nav-wrap::after {
      height: 1px;
      background-color: #e5e5e5;
    }
    /deep/.el-tabs.el-tabs--top {
      height: auto !important;
    }
  }
  /deep/.el-dialog__body {
    padding: 15px 20px 36px 20px;
  }
  /deep/.el-dialog__headerbtn .el-dialog__close {
    font-size: 20px;
  }
}
/deep/.el-dialog {
  position: absolute;
  top: 50%;
  margin-top: -144px !important;
  left: 50%;
  margin-left: -210px;
}
.ontop {
  height: 68px;
  position: fixed;
  top: 0;
  left: 0;
  background-color: white;
  width: 100%;
  z-index: 2004;
  border-bottom: 1px solid #e5e5e5;
  .topwrap {
    width: 1200px;
    margin: 0 auto;
    position: relative;
  }
  /deep/.el-tabs__item.is-top {
    height: 67px;
    line-height: 66px;
    color: #999999;
    font-size: 18px;
  }
  /deep/ .el-tabs__active-bar {
    background-color: #3FA6FF;
    background-color: var(--df-primary-color, #3FA6FF);
  }

  /deep/.el-tabs__active-bar.is-top {
    width: 71px;
    height: 4px;
  }
  /deep/.el-tabs__nav-wrap::after {
    background-color: #e0e6ed;
    height: 0;
  }
  /deep/.el-tabs.el-tabs--top {
    height: auto !important;
  }
  .nowbuy {
    cursor: pointer;
    width: 180px;
    height: 44px;
    background: #3FA6FF;
    background: var(--df-primary-color, #3FA6FF);
    border-radius: 4px;
    line-height: 44px;
    text-align: center;
    font-size: 16px;
    color: white;
    position: absolute;
    right: 0;
    top: 12px;
  }
  .wait {
    background: linear-gradient(
      200deg,
      rgba(92, 180, 236, 1) 0%,
      rgba(61, 150, 226, 1) 100%
    );
    opacity: 0.6;
  }
  .diasbel {
    background: rgba(233, 235, 237, 0.4);
    color: #d5d8db;
  }
}
</style>
